module.exports = __webpack_public_path__ + "static/L2_visual_4_eg-8e2b319e3f7cc2f099e8b12b77f582ee.png";